export default __webpack_public_path__ + "static/media/73t.77241c6b.jpg";